<template lang="pug">
    div.preview(v-if="url")
        div.previewImg
            img(:src="url")
        div.previewFooter
            div.previewName
                div.previewNameLabel Image name
                div.ellipsis {{ name }}
            div.previewActions
                button-component(:action="deleteCallback"
                    color="primary"
                    small)
                    span {{ $t('defaultButtons.delete') }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Button from '../Button';

    export default {
        components: {
            ButtonComponent: Button
        },
        props: {
            url: VueTypes.string.def(''),
            name: VueTypes.string.def(''),
            deleteCallback: VueTypes.func.def(() => {})
        }
    };
</script>

<style scoped lang="stylus">
    @import "../../assets/style/_variables.styl";

    .preview
        width: 100%
        background: $theme.secondary
        border-radius: 10px
        display: flex
    .previewImg
        width: 200px
        border-radius: 10px
        overflow: hidden
        img
            max-width: 100%
            display: block

    .previewFooter
        padding: 15px
        display: flex
        flex-direction: column
        justify-content: space-between

    .previewNameLabel
        text-transform: uppercase
        font-size: 10px

    .deleteAction
        display: inline-block

        .v-icon
            padding-right: 5px
            color: $theme.darkGrey
</style>
